export class ReminderDelayRequest {
  id?: number;
  remindDate?: Date;
}
